<template lang="html">
  <div :style="embedContainerStyle" class="embed-container">
    <div v-if="!dataBound" class="mx-auto" style="width: 200px;">
      <b-spinner small label="Loading..." class="mr-2" />Parsing zip file ...
    </div>
    <SoundslidesPlayer
      v-if="dataBound"
      ref="editPlayer"
      :editing_initial_slide_data="show.slideArray"
      :editing_initial_overlay_data="show.overlayArray"
      :editing_initial_settings_data="show.displaySettings"
      :editing_audio_source_url="show.audioBlob"
      :editing_audio_duration="show.duration"
      :force_preload="true"
      :fillscreen="false"
    />
  </div>
</template>

<script>
import SoundslidesPlayer from "@/components/SoundslidesPlayer/SoundslidesPlayer";
export default {
  name: "DirectoryPlayer",
  components: {
    SoundslidesPlayer
  },
  props: {
    show: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dataBound: false
    };
  },
  computed: {
    embedContainerStyle() {
      var _style = {};
      var padding =
        100 / (this.show.displaySettings || {}).aspectRatio || 66.63;
      _style["padding-bottom"] = padding + "%";
      return _style;
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.dataBound = true;
    });
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.embed-container {
  position: relative;
  padding: 0;
  //padding-bottom: 66.63%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}
</style>
